import { api } from 'app/api/client';
import { UserRoutes} from 'app/_modules/user/api/routes';
import { TMeResponse } from '../types';

export const userApi = {
  getMe(): Promise<TMeResponse> {
    return api.get<TMeResponse>(UserRoutes.users.me());
  },
};
